import React from "react";
import {
    ErrorText,
    PortalFormDescription,
    PortalFormFieldGroup,
    PortalFormLabel,
    PortalOptionButton,
    PortalOptionGrid,
    StandardModalActionButton,
    ValidatedDateInput
} from "src/components";
import { NOTIFICATION_EMAIL_TYPE } from "../../../constants";
import styled from "styled-components";

const SchedulePickerContainer = styled.div`
    display: grid;
    gap: 0.5rem;
    width: 100%;
    max-width: 448px;
`;

const ScheduleControls = styled.div`
    display: grid;
    gap: 0.85rem;
    min-width: 0;
`;

export default function ScheduleOrSendNow(props) {
    const { sendType, setSendType, sendSchedule, setSendSchedule, errors, setErrors, setShowTestEmails, validateForSendTestEmail } = props;

    const onSchedule = () => {
        setSendType(NOTIFICATION_EMAIL_TYPE.SCHEDULE);
        setSendSchedule(null);
    };
    const onSendNow = () => {
        setSendType(NOTIFICATION_EMAIL_TYPE.SEND_NOW);
        setSendSchedule(new Date());
        setErrors({ ...errors, dateTime: "" });
    };

    return (
        <PortalFormFieldGroup>
            <PortalFormLabel>
                Schedule Or Send
            </PortalFormLabel>
            <PortalFormDescription>
                Decide when to send your campaign, immediately or at a future date and time.
            </PortalFormDescription>
            <ScheduleControls>
                <PortalOptionGrid>
                    <PortalOptionButton
                        type="button"
                        width="10.5rem"
                        active={sendType === NOTIFICATION_EMAIL_TYPE.SCHEDULE}
                        onClick={() => onSchedule()}
                    >
                        Schedule
                    </PortalOptionButton>

                    <PortalOptionButton
                        type="button"
                        width="10.5rem"
                        active={sendType === NOTIFICATION_EMAIL_TYPE.SEND_NOW}
                        onClick={() => onSendNow()}
                    >
                        Send Now
                    </PortalOptionButton>

                    <StandardModalActionButton type="button" $variant="primary" onClick={() => validateForSendTestEmail(setShowTestEmails)}>
                        Send Test
                    </StandardModalActionButton>
                </PortalOptionGrid>
                <SchedulePickerContainer>
                    <ValidatedDateInput
                        placeholder="Select date & time"
                        onChange={(event) => {
                            setSendSchedule(event);
                        }}
                        // errors={surveyStartDateError}
                        value={sendSchedule}
                        disabled={sendType === NOTIFICATION_EMAIL_TYPE.SEND_NOW}
                        minDate={new Date()}
                        // showErrors={}
                        size={"0.938rem"}
                        showTime={true}
                        dateTimeColumns="repeat(2, minmax(13.25rem, 1fr))"
                        fontWeight={"400"}
                        style={{
                            border: errors.dateTime ? "1px solid red" : "1px solid #D8DEEC",
                        }}
                    />
                    <ErrorText>{errors.dateTime}</ErrorText>
                </SchedulePickerContainer>
            </ScheduleControls>
        </PortalFormFieldGroup>
    );
}
